module.exports = __webpack_public_path__ + "static/media/logo.56a758f4.zip";